import { useEffect, useMemo } from 'react'

import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes.ts'

import { promoStore } from 'widgets/avia'

import { Promotions } from 'shared/ui/promotions'
import { PagesModule } from 'shared/ui/tabs-pages'

interface Props {
  type: PagesModule
}

export const PromotionsBlock = observer(({ type }: Props) => {
  const navigate = useNavigate()

  const isLoading = promoStore.isLoading

  const promoList = promoStore.getPromoState(type)

  const onNavigate = (id: string) => {
    navigate(RoutingPaths.promo.path(id))
  }

  const getPromoList = () => {
    promoStore.getPromo(type)
  }

  useEffect(() => {
    if (!promoList?.length) {
      getPromoList()
    }
  }, [])

  const listPromo = useMemo(
    () =>
      promoList?.map((promo) => ({
        title: promo.title,
        id: promo.id,
        baner: promo.baner,
      })),
    [promoList, type],
  )

  return (
    <Promotions
      isLoading={isLoading}
      promoList={listPromo}
      onDetail={onNavigate}
    />
  )
})
